import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRequestItem } from 'src/app/_models/PSP/psp-history-requests.model';
import { IStockHistoryitem } from 'src/app/_models/PSP/psp-history-stock.model';
import { IAddStock, IProducts, IPspPharmacyDetails} from 'src/app/_models/PSP/psp-pharmacy-details.model';
import { GenericResponse, Pagination, SuccessResponse } from 'src/app/_models/response.model';


@Injectable({
  providedIn: 'root'
})
export class PspPharmacyDetailsService {
  getPharmacyDetailsUrl ='api/AdminPspPharmacies/GetPharmacyDetails';
  getCurrentStockUrl ='api/PspPharmacyStocks/GetCurrentStock';
  addStockUrl ='api/PspPharmacyStocks/AddStock';
  getPspPharmacyRequestsHistoryUrl = 'api/AdminPspMedicationRequests/GetPspPharmacyRequestsHistory';
  getPspPharmacyStockHistoryUrl='api/PspPharmacyStocks/GetPspPharmacyStocksHistory';
constructor(private http: HttpClient) { }

  getPharmacyDetails(pharmacyErpId:string): Observable<GenericResponse<IPspPharmacyDetails>> {
    let params = new HttpParams().set('pharmacyErpId', pharmacyErpId);
    return this.http.get<GenericResponse<IPspPharmacyDetails>>(this.getPharmacyDetailsUrl, {params: params});
  }

  getCurrentStock(pharmacyErpId:string, pspCompanyId:number|null): Observable<GenericResponse<IProducts>> {
    let params = new HttpParams().set('pharmacyErpId', pharmacyErpId)
    if(pspCompanyId){
      params= params.set('pspCompanyId', pspCompanyId.toString())
    }

    return this.http.get<GenericResponse<IProducts>>(this.getCurrentStockUrl, {params: params});
  }

  addStock(body:IAddStock): Observable<SuccessResponse>{
    return this.http.post<SuccessResponse>(this.addStockUrl,body);
  }

  getPspPharmacyRequestsHistory(pharmacyErpId,currentPage,pageSize): Observable<GenericResponse<{ items: IRequestItem[]; pagination: Pagination }>>{
    let params = new HttpParams().set('pharmacyErpId', pharmacyErpId)
    .set('currentPage', currentPage)
    .set('pageSize', pageSize)
    return this.http.get<GenericResponse<{ items: IRequestItem[]; pagination: Pagination }>>(this.getPspPharmacyRequestsHistoryUrl, {params: params});
  }

  getPspPharmacyStockHistory(pharmacyErpId,currentPage,pageSize): Observable<GenericResponse<{ items:IStockHistoryitem[]; pagination: Pagination }>>{
    let params = new HttpParams().set('pharmacyErpId', pharmacyErpId)
    .set('currentPage', currentPage)
    .set('pageSize', pageSize)
    return this.http.get<GenericResponse<{ items:IStockHistoryitem[]; pagination: Pagination }>>(this.getPspPharmacyStockHistoryUrl, {params: params});
  }



}
